import ContactCard from '@/components/contact/card/ContactCard.vue'
import ReportsList from '@/components/reports/list/ReportsList.vue'
import ClientContractCard from '@/components/client/contract/card/ClientContractCard.vue'
import HomeCards from '@/components/homecards/HomeCards.vue'
import ClientEditSimple from '@/components/client/edit/simple/ClientEditSimple.vue'
import TemporarySystemNotice from '@/components/common/temporarysystemnotice/TemporarySystemNotice.vue'
import { mapState } from 'vuex'

export default {
  components: {
    ContactCard,
    ClientContractCard,
    ReportsList,
    HomeCards,
    ClientEditSimple,
    TemporarySystemNotice
  },
  data () {
    return {
      loading: true,
      client: null,
      clientApiId: null
    }
  },
  computed: {
    ...mapState(['config']),
    editBasicData () {
      const clientPerm = this.$session.get('client_permissions');
      if (
        !this.$session.get('isSimUser') && !this.ApiRequest.userHasPermission('edit-clients') &&
        this.clientApiId && clientPerm[this.clientApiId] && clientPerm[this.clientApiId].needUpdate
      ) {
        return true;
      }
      return false;
    },
    clientIsBlocked () {
      return this.BasicHelper.isUserClientBlocked();
    },
    clientManager () {
      if (this.client && this.client.manager_id) {
        return this.$store.getters.getDataFromConfigById('managers', this.client.manager_id);
      }
      return null;
    },
    isD365BillingEnabled () {
      return !!this.BasicHelper.getObjectValueByString(this.config, 'plugins.d365_api.enabled');
    },
    clientBalance () {
      if (this.client) {
        if (this.isD365BillingEnabled) {
          return parseFloat(this.client.balanceAdvanceBill || 0) + parseFloat(this.client.d365Balance || 0);
        }
        return parseFloat(this.client.balance || 0) + parseFloat(this.client.balanceAdvanceBill || 0) + parseFloat(this.client.balanceOpenOrders || 0);
      }
      return 0;
    }
  },
  methods: {
    getBasicClientData () {
      if (this.clientApiId) {
        const self = this;
        this.ApiRequest.request('client/single/' + this.clientApiId + '/simple', this.ApiRequest.REQUEST_GET, {}, function (response) {
          if (response.data) {
            self.client = response.data;
          }
          self.loading = false;
        });
      } else {
        this.loading = false;
      }
    },
    viewUnpaidBills (newtab = false) {
      const filters = {
        bill_number: '',
        reportSubCode: [],
        fromDatePeriod: null,
        toDatePeriod: null,
        isPaid: [0],
        onlyMine: [],
        managers: [],
        displayColFilters: true
      };
      this.BasicHelper.updateFilterValues('menu.clients.bills', filters);
      if (newtab) {
        const routeData = this.$router.resolve({ name: 'menu.clients.bills' });
        window.open(routeData.href, '_blank');
      } else {
        this.$router.push('/bills/list');
      }
    }
  },
  mounted () {
    this.clientApiId = this.BasicHelper.getUserClientApiId();
    this.getBasicClientData();
  }
}
